import { Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import React, { ReactNode } from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

export interface IIllustrationCardProps {
  illustration: ReactNode;
  action: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
}

export function IllustrationCard({
  illustration,
  action,
  title,
  description,
}: IIllustrationCardProps): JSX.Element {
  const { isDesktop, isPhone } = useScreenSizes();
  const isHorizontal = !!title;

  if (!isHorizontal) {
    return (
      <Flex flexDirection="column" alignItems="center">
        <Stack y="md">{illustration}</Stack>
        <Flex
          width={isPhone ? '100%' : '60%'}
          justifyContent="center"
          alignItems="center"
        >
          {action}
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex flexDirection="column">
      <Flex flexDirection="row" alignItems="center">
        <Flex flexShrink={0}>
          <Stack x="md">{illustration}</Stack>
        </Flex>
        <Flex flexDirection="column" flex={1}>
          <Stack y="sm">{title}</Stack>
          <Stack y={isDesktop ? 'md' : 'none'}>{description}</Stack>
          {isDesktop && action}
        </Flex>
      </Flex>
      {!isDesktop && (
        <Stack mt={6}>
          <Flex width="100%">{action}</Flex>
        </Stack>
      )}
    </Flex>
  );
}
